<template>
  <v-card
    class="d-flex flex-column"
    max-width="450px"
    style="padding-bottom: 10px"
  >
    <v-img :src="image" height="200px" cover></v-img>

    <v-card-title class="text-start"> {{ title }} </v-card-title>
    <v-card-subtitle class="text-start"> {{ subtitle }} </v-card-subtitle>
    <v-card-text class="text-start"> {{ description }} </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions class="justify-center">
      <v-btn color="primary" variant="outlined" :to="demo_link" class="mr-4">
        Demo
      </v-btn>
      <v-btn color="secondary" variant="outlined" :to="customize_link">
        Customize
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "GameCard",
  props: {
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    demo_link: {
      type: String,
      required: true,
    },
    customize_link: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.full-width {
  width: 100%;
}
</style>
